export async function throwWhenUndefined<T>(promise: Promise<T | undefined>, errorMessage?: string): Promise<T> {
    const result = await promise;
    if (result === undefined) {
        throw new Error(errorMessage ?? 'Result was undefined');
    }

    return <T>result;
}
